<button type="button" class="mobile-scroll-bottom-btn" (click)="scrollToPageBottom()" aria-label="Scroll to bottom of page">
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M12 4V20M12 20L18 14M12 20L6 14" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</button>
